<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Lopez">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Lopez"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. José Dimas López Martínez</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> jose_dimaslopez@hotmail.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> 1
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p>Desarrollo Agrícola Sustentable</p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            ING. EN FITOTECNIA (1982)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            FACULTAD DE AGRICULTURA Y ZOOTECNIA
                            <br>
                            UJED
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>SUELO (1989)</li>
                            <p>
                                INSTITUTO TECNOLOLOGICO AGROPECUARIO No. 10
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>AGUA-SUELO (1997)</li>
                            <p>
                                FACULTAD DE AGRONOMIA
                                <br>
                                UANL
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>ESTADÍSTICA</li>
                            <li>RELACIÓN AGUA-SUELO</li>
                            <li>AGRICULTURA ORGANICA</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/lopez.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'RENDIMIENTO Y COMPONENTES DE PRODUCCION DE HIBRIDOS DE MAIZ EN LA COMARCA LAGUNERA ( Yield adn production components in maize hybrids in the Comarca Lagunera)',
                    publicacion: 2018,
                },
                {
                    numero: 2,
                    titulo: 'OPUNTIA FORAGE( Opuntia Ficus-Indica L.) Response to Solarized Cattle Manure Amendments in Four Plant Densities',
                    publicacion: 2017,
                },
                {
                    numero: 3,
                    titulo: 'Efecto del potasio en el contenido fenolico y capacidad antioxidante de Ocimum Basilicum L.  ( Effect of potassium on the phenolic content and antioxidant capacity of Ocimum basilicum L.',
                    publicacion: 2017,
                },
                {
                    numero: 4,
                    titulo: 'YIELD AND NUTRACEUTICAL QUALITY OF TOMATO FRUIT PRODUCED WITH NUTRIENT SOLUTIONS PREPARED USING ORGANIC MATERIALS ( Rendimiento y Calidad Nutraceutica de frutos de tomate producidos con soluciones nutritiva preparadas con materiales organicos',
                    publicacion: 2016,
                },
                {
                    numero: 5,
                    titulo: 'Determinacion preliminar de normas e interacciones nutrimentales en chile ancho (Capsicum annuum L) en la Comarca Lagunera Preliminary detemination of nutrient norms and nutrient interactions on pepper "ancho" (Capsicum annuum L) in the Comarca Lagunera',
                    publicacion: 2016
                },
                {
                    numero: 6,
                    titulo: 'Long Term of Cattle Manure Amendments and Its Impact on Triticale (X. Triticosecale Wittmack) Productiono and Soil Quality',
                    publicacion: 2016
                },
                {
                    numero: 7,
                    titulo: 'OPTENCION DE HIBRIDOS DE MAIZ PARA GRANO EN LA COMARCA LAGUNERA Y AGUASCALIENTES, MEXICO (Obtaining of corn hybrids for grain in the Comarca Lagunera and Aguascalientes, Mexico.',
                    publicacion: 2015
                },
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'CARACTEIZACION FISICA Y QUIMICA DE ABONOS ORGANICOS BAJO TRATAMIENTOS DE SOLARIZACION.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'CARACTERIZACION MORFOLOGICA, BIOQUIMICA Y GENETICA DE POBLACIONES SILVESTRES Y CRIOLLAS DE CHILE ADAPTADAS A LOS AMBIENTES DE LAS ZONAS ARIDAS Y SEMIÁRIDAS DEL NORTE DE MEXICO.',
                    tipo: 'INTERNO'
                },
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
